/**
 * @generated SignedSource<<5580410352c938422018ad3565261a02>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Locale = "EN" | "LT";
import { FragmentRefs } from "relay-runtime";
export type EditorTranslateButton_from$data = {
  readonly locale: Locale;
  readonly " $fragmentType": "EditorTranslateButton_from";
};
export type EditorTranslateButton_from$key = {
  readonly " $data"?: EditorTranslateButton_from$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditorTranslateButton_from">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditorTranslateButton_from",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "locale",
      "storageKey": null
    }
  ],
  "type": "Language",
  "abstractKey": null
};

(node as any).hash = "2c30830b3eb04e7ed8bba99961a12a1b";

export default node;
